module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disclaimer"
  }, [(_vm.logoWidth >= 0) ? _c('img', {
    class: [
      "disclaimer__logo",
      "disclaimer__logo--ext",
      ("disclaimer__logo--" + _vm.logoRatio) ],
    attrs: {
      "alt": ((_vm.org.program_name) + " logo"),
      "src": _vm.logoSrc
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.org.is_no_of_sessions_hidden) ? [_c('h3', {
    staticClass: "h3 disclaimer__title"
  }, [_vm._v(_vm._s(((_vm.org.number_of_sessions) + " covered session" + (_vm.org.number_of_sessions > 1 ? "s" : "") + " " + (_vm.org.session_frequency))))]), _vm._v(" "), _c('p', {
    staticClass: "p disclaimer__description"
  }, [_vm._v(_vm._s(_vm.org.program_name) + " covers the full cost of up to " + _vm._s(_vm.org.number_of_sessions) + " session" + _vm._s(_vm.org.number_of_sessions > 1 ? "s" : "") + " " + _vm._s(_vm.org.session_frequency) + ". There’s no co-pay and you don’t need to use your health insurance.")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d6eb3b2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Disclaimer.vue
// module id = 470
// module chunks = 0